var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _path2, _rect9, _rect10, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 449,
    viewBox: "0 0 449 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 94.7278,
    width: 366,
    height: 366,
    transform: "rotate(-15 0 94.7278)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2701,
    y: 108.163,
    width: 152,
    height: 152,
    transform: "rotate(-15 23.2701 108.163)",
    stroke: "#756CAD",
    strokeWidth: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.8223,
    y: 278.166,
    width: 152,
    height: 152,
    transform: "rotate(-15 68.8223 278.166)",
    stroke: "#756CAD",
    strokeWidth: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 193.273,
    y: 62.6107,
    width: 152,
    height: 152,
    transform: "rotate(-15 193.273 62.6107)",
    stroke: "#756CAD",
    strokeWidth: 8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 238.825,
    y: 232.614,
    width: 152,
    height: 152,
    transform: "rotate(-15 238.825 232.614)",
    stroke: "#756CAD",
    strokeWidth: 8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 315.47,
    y: 116.831,
    width: 72,
    height: 56,
    transform: "rotate(75 315.47 116.831)",
    fill: "#756CAD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 118.015,
    y: 260.844,
    width: 136,
    height: 56,
    transform: "rotate(75 118.015 260.844)",
    fill: "#756CAD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.647 136.15L216.327 164.102L201.833 110.01L279.107 89.3049C294.044 85.3025 309.397 94.1668 313.4 109.104L320.647 136.15Z",
    fill: "#756CAD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 200.872,
    y: 168.243,
    width: 108,
    height: 56,
    transform: "rotate(165 200.872 168.243)",
    fill: "#756CAD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.976,
    cy: 159.056,
    rx: 5,
    ry: 8,
    transform: "rotate(-15 126.976 159.056)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.802,
    cy: 127.511,
    rx: 3.02358,
    ry: 19.344,
    transform: "rotate(15 134.802 127.511)",
    fill: "#756CAD"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.782,
    cy: 404.115,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 108.782 404.115)",
    fill: "#756CAD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.785,
    cy: 358.563,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 278.785 358.563)",
    fill: "#756CAD"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.1,
    cy: 398.939,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 128.1 398.939)",
    fill: "#756CAD"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.103,
    cy: 353.386,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 298.103 353.386)",
    fill: "#756CAD"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.419,
    cy: 393.762,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 147.419 393.762)",
    fill: "#756CAD"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 317.422,
    cy: 348.21,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 317.422 348.21)",
    fill: "#756CAD"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.738,
    cy: 388.586,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 166.738 388.586)",
    fill: "#756CAD"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.74,
    cy: 343.034,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 336.74 343.034)",
    fill: "#756CAD"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.056,
    cy: 383.41,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 186.056 383.41)",
    fill: "#756CAD"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 356.059,
    cy: 337.857,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 356.059 337.857)",
    fill: "#756CAD"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.375,
    cy: 378.233,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 205.375 378.233)",
    fill: "#756CAD"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.378,
    cy: 332.681,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 375.378 332.681)",
    fill: "#756CAD"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.693,
    cy: 373.057,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 224.693 373.057)",
    fill: "#756CAD"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.696,
    cy: 327.505,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 394.696 327.505)",
    fill: "#756CAD"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.012,
    cy: 367.88,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 244.012 367.88)",
    fill: "#756CAD"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.015,
    cy: 322.328,
    rx: 6,
    ry: 18,
    transform: "rotate(-15 414.015 322.328)",
    fill: "#756CAD"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.6102,
    cy: 136.94,
    rx: 3.02358,
    ry: 19.344,
    transform: "rotate(15 99.6102 136.94)",
    fill: "#756CAD"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.93,
    cy: 166.303,
    rx: 5,
    ry: 8,
    transform: "rotate(-15 99.93 166.303)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.926 229.785L338.246 201.833L345.493 228.879C349.496 243.816 340.631 259.169 325.694 263.171L248.42 283.877L233.926 229.785Z",
    fill: "#756CAD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63.9233,
    y: 275.337,
    width: 160,
    height: 56,
    transform: "rotate(-15 63.9233 275.337)",
    fill: "#756CAD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 84.6288,
    y: 352.611,
    width: 160,
    height: 56,
    transform: "rotate(-15 84.6288 352.611)",
    fill: "#756CAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.632 307.059L382.134 272.895C397.071 268.893 412.424 277.757 416.427 292.694L423.674 319.74L269.126 361.151L254.632 307.059Z",
    fill: "#756CAD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnake);
export default __webpack_public_path__ + "static/media/snake.7fac9804bc379076155dd6d9ee7cae15.svg";
export { ForwardRef as ReactComponent };